<template>
	<div>
		<div
			v-for="(skirental, index) in cart.skirental"
			:key="skirental.uniqueId"
			class="cart-list__item grid-x"
		>
			<div class="cell small-3 medium-2">
				<!-- Image -->
				<img class="cart-list__image" :src="skirental.image" alt="cart image" />
			</div>

			<div class="cell small-9 medium-2 cart-list__mobile-header">
				<span class="cart-list__item-no">
					{{ $t('skirental.skirental') }} {{ index + 1 }}
				</span>
				<span class="cart-list__heading cart-list__heading--small">
					<span v-if="skirental.isForSale" class="cart-list__heading-text">
						{{ skirental.name }}
					</span>
					<span v-if="!skirental.isForSale" class="cart-list__heading-text">
						{{ skirental.name }}
						<!-- {{ skirental.ageGroup ? `(${skirental.ageGroup})` : '' }} -->
						{{ skirental.cat ? '(' + skirental.cat.split(' ')[0] + ')' : '' }}
						<span>
							{{ dateDiff(skirental.startDate, skirental.endDate) }}
							{{ dayordays(dateDiff(skirental.startDate, skirental.endDate)) }}
						</span>
					</span>
					<span
						class="cart-list__heading-levels"
						v-if="
							(skirental.isPackage && !skirental.isForSale) ||
							(skirental.levels &&
								skirental.levels.length != 3 &&
								!skirental.isForSale)
						"
					>
						<LevelLabel
							v-for="level in skirental.levels"
							:key="level.id"
							:level="level.id"
						>
							{{ level.label }}
						</LevelLabel>
					</span>
					<span class="cart-list__heading-buy" v-if="skirental.isForSale">
						köp
					</span>
				</span>
			</div>

			<div class="cell small-12 medium-10">
				<!-- Buttons -->
				<div class="cart-list__buttons">
					<Button
						size="square"
						color="red"
						@click.native="
							() =>
								!skirental.detlid ? showRemoveProductModal(skirental) : () => {}
						"
						:disabled="skirental.detlid ? true : false"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
					</Button>
				</div>

				<!-- Card -->
				<div class="cart-list__card">
					<!-- Head -->
					<div class="cart-list__head cart-list__head--with-border grid-x">
						<div class="cell small-12">
							<span class="cart-list__item-no">
								{{ $t('skirental.skirental') }} {{ index + 1 }}
							</span>
							<span class="cart-list__heading">
								<span
									v-if="skirental.isForSale"
									class="cart-list__heading-text"
								>
									{{ skirental.name }}
								</span>
								<span
									v-if="!skirental.isForSale"
									class="cart-list__heading-text"
								>
									{{ skirental.name }}
									<!-- {{ skirental.ageGroup ? `(${skirental.ageGroup})` : '' }} -->
									{{
										skirental.cat ? '(' + skirental.cat.split(' ')[0] + ')' : ''
									}}
									<span>
										{{ dateDiff(skirental.startDate, skirental.endDate) }}
										{{
											dayordays(
												dateDiff(skirental.startDate, skirental.endDate)
											)
										}}
									</span>
								</span>
								<span
									class="cart-list__heading-levels"
									v-if="
										(skirental.isPackage && !skirental.isForSale) ||
										(skirental.levels &&
											skirental.levels.length != 3 &&
											!skirental.isForSale)
									"
								>
									<LevelLabel
										v-for="level in skirental.levels"
										:key="level.id"
										:level="level.id"
									>
										{{ level.label }}
									</LevelLabel>
								</span>
								<span class="cart-list__heading-buy" v-if="skirental.isForSale">
									köp
								</span>
							</span>
						</div>
						<div
							v-if="skirental.isForSale"
							class="cart-list__price cell small-12 medium-4"
						>
							<span class="cart-list__heading">
								{{ convertPrice(skirental.price) }} SEK
							</span>
						</div>
					</div>

					<!-- Body -->
					<div
						v-if="!skirental.isForSale"
						class="cart-list__body cart-list__body--with-upper-border"
					>
						<SetProductCompanion
							:product="skirental"
							:productType="'skirental'"
						/>
						<div class="cart-list__table">
							<div class="cart-list__table-head grid-x">
								<div class="cell show-for-medium medium-2">
									<span>{{ $t('cart.price') }}</span>
								</div>
								<div class="cell small-3 medium-2">
									<span>{{ $t('cart.total') }}</span>
								</div>
							</div>
							<div class="cart-list__table-item grid-x">
								<div class="cart-list__table-label cell small-8">
									{{ skirental.displayLength }} ({{
										formatDateSpan(skirental.startDate, skirental.endDate)
									}})
								</div>
								<div class="cart-list__table-price cell small-4">
									{{ convertPrice(skirental.price) }} SEK
								</div>
							</div>

							<ProductAddon
								:id="skirental.uniqueId"
								:addon="'insurance'"
								:price="skirental.priceWithInsurance - skirental.price"
								:isChecked="skirental.insurance"
								@on-change-insurance="updateAddon"
								:isDisabled="
									!skirental.allowmodify || skirental.insurance_original
								"
							/>

							<!-- Comment field for this products: Alpint Klädpaket Fodrat (1385), Jacka Skal (2970), Jacka Fodrad (2971), Kläder Byxor (2972), Kläder Handskar (2973) -->
							<ProductAddon
								v-if="
									skirental.poollid == 1385 ||
									skirental.poollid == 2970 ||
									skirental.poollid == 2971 ||
									skirental.poollid == 2972 ||
									skirental.poollid == 2973
								"
								:id="skirental.uniqueId"
								:addon="'comment'"
								:label="'Lägg till önskad storlek'"
								:isChecked="convertToBool(skirental.comment)"
								:value="skirental.comment"
								:isDisabled="!skirental.allowmodify"
								@on-change-comment="updateAddon"
							/>
						</div>
					</div>

					<!-- Foot -->
					<div v-if="!skirental.isForSale" class="card-list__foot">
						<div class="cart-list__price">
							<span class="cart-list__heading">
								{{ productAndAddonPrice(skirental) }} SEK
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Delivery -->
		<div
			class="cart-list__item cart-list__item--addon grid-x"
			v-if="cart.deliveryPrice !== -1"
		>
			<div class="cell small-12 medium-10 medium-offset-2">
				<div class="cart-list__card">
					<div class="cart-list__icon">
						<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon arrow-down'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill-rule="evenodd"/></svg>
					</div>

					<!-- Body -->
					<div class="cart-list__body">
						<div class="cart-list__table">
							<div class="cart-list__table-head grid-x">
								<div class="cell small-12 medium-8">
									<span class="cart-list__addon">
										{{ $t('skirental.addonListLabel') }}
									</span>
								</div>
								<div class="cell show-for-medium medium-2">
									<span>{{ $t('cart.price') }}</span>
								</div>
								<div class="cell small-3 medium-2">
									<span>{{ $t('cart.total') }}</span>
								</div>
							</div>

							<ProductAddon
								:id="'1'"
								:addon="'delivery'"
								:price="cart.deliveryPrice"
								:isChecked="cart.delivery"
								:isDisabled="
									cart.allowmodification === false ||
									cart.delivery_original == true
								"
								:tooltipTitle="$t('skirental.deliveryTooltipTitle')"
								:tooltipText="$t('skirental.deliveryTooltipText')"
								@on-change-delivery="updateDelivery"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal: Remove product -->
		<Modal
			v-show="showModal"
			:disableClose="true"
			:maxWidth="640"
			:heading="$t('cart.remove')"
			:text="
				this.product.name +
				' (' +
				this.product.ageGroup +
				') ' +
				product.displayLength
			"
			:closeCta="true"
			:closeCtaText="$t('cart.close')"
			@close="showModal = false"
		>
			<template v-slot:buttons>
				<Button @click.native="removeProduct(product.uniqueId)">
					{{ $t('cart.remove') }}
				</Button>
			</template>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Button from '../atoms/Button'
import LevelLabel from '../atoms/LevelLabel'
import ProductAddon from '../molecules/ProductAddon.vue'
import SetProductCompanion from '../molecules/SetProductCompanion'
import Modal from '../molecules/Modal'

export default {
	name: 'CartSkirental',
	store,
	mixins: [mixin],
	components: {
		SetProductCompanion,
		Button,
		LevelLabel,
		ProductAddon,
		Modal
	},
	computed: {
		cart() {
			return store.state.cart
		},
		user() {
			return store.state.user
		}
	},
	data() {
		return {
			showModal: false,
			product: {
				name: '',
				uniqueId: '',
				ageGroup: '',
				displayLength: ''
			}
		}
	},
	props: {},
	methods: {
		//To do - move to action?
		showRemoveProductModal(product) {
			this.product.name = product.name
			this.product.uniqueId = product.uniqueId
			this.product.ageGroup = product.ageGroup
			this.product.displayLength = product.displayLength

			this.showModal = true
		},
		removeProduct(id) {
			store
				.dispatch('REMOVE_CART_SKIRENTAL', {
					uniqueId: id
				})
				.then(() => {
					this.product.name = ''
					this.product.uniqueId = ''
					this.product.ageGroup = ''
					this.product.displayLength = ''

					this.showModal = false

					if (store.state.cart.cartCheckoutClicked) {
						store.dispatch('VALIDATE_PRODUCTS_IN_CART')
					}
				})
		},
		updateAddon(value, id, type) {
			const actionName = 'GET_CART_SKIRENTAL_' + type.toUpperCase()
			store
				.dispatch(actionName, {
					value: value,
					uniqueId: id
				})
				.then(() => {
					this.cart.skirental = store.state.cart.skirental
				})
		},
		updateDelivery(val, type) {
			//Delivery addon added, but no type chosen (val = true/false)
			if (typeof val == 'boolean') {
				if (val && this.cart.accommodation.length) {
					store.dispatch('UPDATE_CART_DELIVERY', {
						delivery: true,
						delivertoaccommodation: this.cart.accommodation[0].unitlid,
						delivertoother: null
					})
				} else {
					store.dispatch('UPDATE_CART_DELIVERY', {
						delivery: false,
						delivertoaccommodation: null,
						delivertoother: null
					})
				}

				//Delivery addon added + set to "freetext" (no yet filled in)
			} else if (val == 1) {
				store.dispatch('UPDATE_CART_DELIVERY', {
					delivery: true,
					delivertoaccommodation: null,
					delivertoother: ''
				})

				//Delivery addon added + set to "freetext" + filled in (val = textareaString)
			} else if (type == 'other' && val) {
				store.dispatch('UPDATE_CART_DELIVERY', {
					delivery: true,
					delivertoaccommodation: null,
					delivertoother: val
				})
				//Delivery addon added + set to booked accommodation (val = accId)
			} else {
				store.dispatch('UPDATE_CART_DELIVERY', {
					delivery: true,
					delivertoaccommodation: val,
					delivertoother: null
				})
			}
		},
		productAndAddonPrice(product) {
			let finalAmount = Number()
			let addonPrice = Number()
			const productPrice = Number(product.price)

			if (product.insurance) {
				addonPrice = product.priceWithInsurance - product.price
			} else {
				addonPrice = 0
			}

			finalAmount = addonPrice + productPrice
			return new Intl.NumberFormat(this.$t('currency')).format(finalAmount)
		}
	}
}
</script>

<style lang="scss" scoped></style>
